import { render, staticRenderFns } from "./shopCommunityWithdraw.vue?vue&type=template&id=0b7f9e9e"
import script from "./shopCommunityWithdraw.vue?vue&type=script&lang=js"
export * from "./shopCommunityWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports